<script>
    import { fade } from 'svelte/transition';
    import Hero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    const src = {
        pc:"img/info-fv.png",
        mb:"img/info-fv_mb.png"
    }
</script>
<svelte:head>
	<title>会社概要 | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <Hero images={src} />
    <Centering>
        <div class="main">
            <div class="row first">
                <h2>会社概要</h2>
                <table>
                    <tr><th>-会社名</th><td>株式会社　有倉商店</td></tr>
                    <tr><th>-代表者</th><td><p>代表取締役　　　升本　正</p><p>取締役社長　　　市原　達朗</p><p>取締役副社長　　塚越 孔三</p><p>取締役統括部長 　阿部　秀幸</p></td></tr>
                    <tr><th>-設立</th><td>1983年（昭和58年）9月1日 </td></tr>
                    <tr><th>-従業員数</th><td>58名（うち正社員28名） </td></tr>
                    <tr><th>-資本金</th><td>1000万円</td></tr>
                    <tr><th>-事業所</th><td>・本社　
〒136-0071　東京都江東区亀戸5丁目33番5号
TEL：03-3684-1875
FAX：03-3684-1814

・亀戸第2センター
東京都江東区亀戸5丁目31番

・市川支社
〒272-0015　千葉県県市川市鬼高4丁目5番1号
（市川地方卸売市場内）
TEL：047-370-0831
FAX：047-370-0836

・葛西市場荷受け及び作業所
東京都江戸川区臨海町3丁目4番1号
（東京都中央卸売市場葛西市場内）</td></tr>
    <tr><th>-関連会社</th><td>株式会社升喜</td></tr>
                        <tr><th>-取引銀行</th><td>三井住友銀行、りそな銀行、みずほ銀行、
小松川信用金庫、東京東信用金庫、他 </td></tr>
                        <tr>
                            <th>-主要仕入先</th>
                            <td>
葛西中央卸売市場、豊洲中央卸売市場、市川地方卸売市場、
千葉地方卸売市場、JA八千代、古川農園、各産地農家、他
                            </td>
                        </tr>
                        <tr>
                            <th>-主要取引先</th>
                            <td>都立・国立・私立病院、都内・千葉県・埼玉県の小中学校及
び保育園、他</td>
                        </tr>
                </table>
            </div>
            <div class="row second" id="history">
                <h2>会社沿革</h2>
                <table>
                    <tr><th>-昭和24年</th><td>東京都江東区大島5丁目50番9号に青果物小売業を営む。</td></tr>
                    <tr><th>-昭和46年</th><td>4月1日より有限会社有倉商店とし、東京都江東区立小中学校への納入を始める</td></tr>
                    <tr><th>-昭和53年</th><td>4月都立病院部門納入を開始。</td></tr>
                    <tr><th>-昭和56年</th><td>11月東京都江東区亀戸５丁目３３番５号に本社移転。</td></tr>
                    <tr><th>-昭和58年</th><td>9月1日株式会社有倉商店として営業開始。</td></tr>
                    <tr><th>-平成16年</th><td>動物園等の入札を開始。</td></tr>
                    <tr><th>-平成17年</th><td>3月中央卸市場葛西市場青果部買参権取得。</td></tr>
                    <tr><th>-平成19年</th><td>江東区亀戸5丁目33番5号の本社新社屋にて営業開始。</td></tr>
                    <tr><th>-平成29年</th><td>6月千葉市卸売市場買参権を取得、同８月中央卸市場築地市場青果部買参権を取得。</td></tr>
                    <tr><th>-平成30年</th><td>3月31日酒類食品卸株式会社升喜と資本業務提携、<br>現在に至る。</td></tr>
                </table>
            </div>
            <div class="row third">
                <div class="image">
                    <h3>本社兼加工場・亀戸第2センター</h3>
                    <img src="img/info-1.png" alt="">
                </div>
                <div class="image">
                    <h3>市川支社(市川市地方卸売市場内)</h3>
                    <img src="img/info-2.png" alt="">
                </div>
            </div>
            <div class="row maps" id="map">
                <div class="content">
                    <h3>本社アクセス</h3>
                    <p>
                        〒136-0071<br>
                        東京都江東区亀戸5丁目33番5号<br>
                        TEL：03-3684-1875<br>
                        <br>
                        【最寄駅からの経路】<br>
                        JR中央・総武線亀戸駅より徒歩4分<br>
                        東武亀戸線亀戸駅より徒歩4分
                    </p>
                </div>
                <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.1235261494207!2d139.82800951561234!3d35.69857773662724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601888c6b9095baf%3A0x2629714766954149!2z44CSMTM2LTAwNzEg5p2x5Lqs6YO95rGf5p2x5Yy65LqA5oi477yV5LiB55uu77yT77yT4oiS77yV!5e0!3m2!1sja!2sjp!4v1624782043745!5m2!1sja!2sjp" width="725" height="520" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
            <div class="row maps second">
                <div class="content">
                    <h3>市川支社アクセス</h3>
                    <p>
                        〒272-0015<br>
                        千葉県県市川市鬼高4丁目5番1号<br>
                        TEL：047-370-0831<br>
                        <br>
                        【最寄駅からの経路】<br>
                        JR中央・総武線本八幡駅より徒歩20分<br>
                        <br>
                        【車での経路】<br>
                        京葉市川ICより3分<br>
                    </p>
                </div>
                <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d404.9587267841773!2d139.92952766005502!3d35.70974210736834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018872ed31b8e6d%3A0xe72b79cfc8261407!2z44CSMjcyLTAwMTUg5Y2D6JGJ55yM5biC5bed5biC6ay86auY77yU5LiB55uu77yV4oiS77yR!5e0!3m2!1sja!2sjp!4v1624782862262!5m2!1sja!2sjp" width="725" height="520" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
        </div>

    </Centering>
</div>


<style>
    .main{
        width:100%
    }
    .first{
        margin-top:70px;
    }
    .row{
        display: flex;
        justify-content: space-between;
        width:100%;
    }
    h2{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 60px;
        line-height: 41px;
        text-align: left;
        color: #000;

    }
    table{
        margin-top: 60px;
    }
    tr{
        display: flex;
        box-sizing: border-box;
        min-height: 54px;
        border-bottom:1px solid #959595;
    }
    th{
        width:232px;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        text-align: left;
        color: #000;
        justify-content: flex-start;
        line-height: 36px;
        padding: 15px 31px;
    }
    td{
        width: 432px;
        white-space: pre;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        text-align: left;
        color: #000;
        line-height: 36px;
        padding: 15px 0;
    }
    td p{
        margin: 0;
    }
    .second{
        margin-top: 120px;
    }
    .second td{
        white-space: normal;
    }
    .third{
        margin-top: 100px;
    }
    h3{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 24px;
        line-height: 41px;
        text-align: left;
        color: #000;
    }
    h3:after{
        width: 46px;
        height: 3px;
        border-radius: 1.5px;
        background: #ff9b11;
        content:"";
        display: block;
    }
    .content h3{
        font-size: 30px;
        letter-spacing: 0.04em;
        line-height: 52px;
        text-align: left;
        color: #373445;
        width: 270px;
    }
    .content{
        margin-top: 40px;
        margin-left: 100px;
        width:400px;
        height: 520px;
    }
    .content p{
        width: 270px;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        letter-spacing: 0.06em;
        line-height: 30px;
        text-align: left;
        color: #373445;
    }
    .maps{
        background-color: #fff;
        display: flex;
        margin-top: 100px;
        height: 520px;
    }
    .maps.second{
        margin-bottom: 125px;
    }
    @media screen and (max-width:640px){
        .row{
            flex-direction: column;
        }
        table{
            display: block;
            width: 100%;
        }
        tr{
            flex-direction: column;
            width: 100%;
        }
        th{
            padding: 0;
            width: 100%;
            font-size: 14px;
        }
        td{
            width: 100%;
            white-space:initial;
            word-wrap: break-word;
            font-size: 14px;
        }
        h2{
            font-size: 40px;
        }
        .image img{
            width: 100%;
        }
        .maps{
            height:650px;
        }
        .content{
            margin-left: 17px;
            margin-top: 25px; 
            height: 650px;
        }
        .content h3{
            margin-top: 0;
            font-size: 16px;
        }
        .content p{
            font-size: 14px;
            width: 100%;
        }
        iframe{
            width: 100%;
        }
        .image h3{
            font-size: 16px;
        }
    }
</style>